import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';
import { BACKGROUND_MUSIC } from '../constants/Constants';
export default class Landing extends SceneBase {
  constructor() {
    super({ key: KEYS.Landing, active: false });
  }
  create() {
    super.create();
    this.game.soundController.playMusic(BACKGROUND_MUSIC.TITLE_PAGE);
    this.add.image(this.game.defaultWidth * 0.5, this.game.defaultHeight * 0.5, 'background_home');
    this.add.image(this.game.defaultWidth * 0.5, 30, 'game_title').setOrigin(0.5, 0);

    if (!this.sound.locked) {
      this.game.vo.playChain(['NFC_1.0_1', 'NFC_1.0_2']);
    }

    this.input.once('pointerup', this.clickToEnter, this);
  }

  clickToEnter() {
    this.game.enterGame(false);
  }
}
